import { EventEmitter } from "@angular/core";
import { AlulaDealer } from "@app/project/model/alula-dealer";
import { AlulaDevice } from "@app/project/model/alula-device";
import { AlulaEvent } from "@app/project/model/alula-event";
import { AlulaReceiver } from "@app/project/model/alula-receiver";
import { AlulaReceiverBind } from "@app/project/model/alula-receiver-bind";
import { AlulaReceiverGroup } from "@app/project/model/alula-receiver-group";
import { AlulaUser } from "@app/project/model/alula-user";
import { Project } from "@app/project/model/project";
import { Action } from "@ngrx/store";
import { DataAction, DataErrorAction, DataSuccessAction } from "../../../shared/resources/data-actions";
import { DataServiceError } from "../../../shared/services/data-service-error";
import { AlulaEventFilter } from "../../model/alula-event";

export enum ActionTypes {
    ClearDevicesByDealerId = "[ Alula ] CreateDevicesbyDealerId",
    CreateAlulaUser = "[ Alula ] CreateAlulaUser",
    CreateAlulaUserSuccess = "[ Alula ] CreateAlulaUserSuccess",
    CreateAlulaUserFailure = "[ Alula ] CreateAlulaUserFailure",
    GetAlulaUser = "[ Alula ] GetAlulaUser",
    GetAlulaUserByPartialUsername = "[ Alula ] GetAlulaUserByPartialUsername",
    GetAlulaUserFailure = "[ Alula ] GetAlulaUserFailure",
    GetAlulaUserSuccess = "[ Alula ] GetAlulaUserSuccess",
    UpdateAlulaUser = "[ Alula ] UpdateAlulaUser",
    UpdateAlulaUserFailure = "[ Alula ] UpdateAlulaUserFailure",
    UpdateAlulaUserSuccess = "[ Alula ] UpdateAlulaUserSuccess",
    CreateAlulaDevice = "[ Alula ] CreateAlulaDevice",
    CreateAlulaDeviceSuccess = "[ Alula ] CreateAlulaDeviceSuccess",
    CreateAlulaDeviceFailure = "[ Alula ] CreateAlulaDeviceFailure",
    GetAlulaDevice = "[ Alula ] GetAlulaDeviceProperties",
    GetAlulaDeviceSuccess = "[ Alula ] GetAlulaDevicePropertiesSuccess",
    GetAlulaDeviceFailure = "[ Alula ] GetAlulaDevicePropertiesFailure",
    GetDevicesByReceiverGroupId = "[ Alula ] GetDevicesByReceiverGroupId",
    GetDevicesByReceiverGroupIdSuccess = "[ Alula ] GetDevicesByReceiverGroupIdSuccess",
    GetDevicesByReceiverGroupIdFailure = "[ Alula ] GetDevicesByReceiverGroupIdFailure",
    GetDevicesByDealerId = "[ Alula ] GetDevicesByDealerId",
    GetDevicesByDealerIdSuccess = "[ Alula ] GetDevicesByDealerIdSuccess",
    GetDevicesByDealerIdFailure = "[ Alula ] GetDevicesByDealerIdFailure",
    GetAlulaDeviceEvents = "[ Alula ] GetAlulaDeviceEventsProperties",
    GetAlulaDeviceEventsSuccess = "[ Alula ] GetAlulaDeviceEventsPropertiesSuccess",
    GetAlulaDeviceEventsFailure = "[ Alula ] GetAlulaDeviceEventsPropertiesFailure",
    UpdateAlulaDevice = "[ Alula ] UpdateAlulaDevice",
    UpdateAlulaDeviceFailure = "[ Alula ] UpdateAlulaDeviceFailure",
    UpdateAlulaDeviceSuccess = "[ Alula ] UpdateAlulaDeviceSuccess",
    EnableSecurityMonitoring = "[ Alula ] EnableSecurityMonitoring",
    EnableSecurityMonitoringSuccess = "[ Alula ] EnableSecurityMonitoringSuccess",
    EnableSecurityMonitoringFailure = "[ Alula ] EnableSecurityMonitoringFailure",
    DisableSecurityMonitoring = "[ Alula ] DisableSecurityMonitoring",
    DisableSecurityMonitoringSuccess = "[ Alula ] DisableSecurityMonitoringSuccess",
    DisableSecurityMonitoringFailure = "[ Alula ] DisableSecurityMonitoringFailure",
    DeactivateSecurityMonitoringConfirmationDismiss = "[ Alula ] DeactivateSecurityMonitoringConfirmationDismiss",
    DeactivateSecurityMonitoring = "[ Alula ] DeactivateSecurityMonitoring",
    AssignAlulaDevice = "[ Alula ] AssignAlulaDevice",
    AssignAlulaDeviceSuccess = "[ Alula ] AssignAlulaDeviceSuccess",
    AssignAlulaDeviceFailure = "[ Alula ] AssignAlulaDeviceFailure",
    UnassignAlulaDevice = "[ Alula ] UnassignAlulaDevice",
    UnassignAlulaDeviceSuccess = "[ Alula ] UnassignAlulaDeviceSuccess",
    UnassignAlulaDeviceFailure = "[ Alula ] UnassignAlulaDeviceFailure",
    UpdateAlulaDeviceReceiver = "[ Alula ] UpdateAlulaDeviceReceiver",
    UpdateAlulaDeviceReceiverSuccess = "[ Alula ] UpdateAlulaDeviceReceiverSuccess",
    UpdateAlulaDeviceReceiverFailure = "[ Alula ] UpdateAlulaDeviceReceiverFailure",
    ClearAlulaState = "[ Alula ] ClearAlulaState",
    LoadAlulaStateItem = "[ Alula ] LoadAlulaStateItem",
    LoadedAlulaStateItem = "[ Alula ] LoadedAlulaStateItem",
    ClearAlulaDevice = "[ Alula ] ClearAlulaDevice",
}

export type AlulaDeviceAction = DataAction<AlulaDevice>;
type AlulaDeviceSuccessAction = DataSuccessAction<AlulaDevice>;
type AlulaDeviceFailureAction = DataErrorAction<AlulaDevice>;

export type AlulaDevicesAction = DataAction<AlulaDevice[]>;
export type AlulaDevicesSuccessAction = DataSuccessAction<AlulaDevice[]>;
type AlulaDevicesFailureAction = DataErrorAction<AlulaDevice[]>;

export type AlulaUserAction = DataAction<AlulaUser>;
type AlulaUserSuccessAction = DataSuccessAction<AlulaUser>;
type AlulaUserFailureAction = DataErrorAction<AlulaUser>;

export type AlulaReceiverAction = DataAction<AlulaReceiver>;
type AlulaReceiverSuccessAction = DataSuccessAction<AlulaReceiver>;
type AlulaReceiverFailureAction = DataErrorAction<AlulaReceiver>;

export type AlulaReceiversAction = DataAction<AlulaReceiver[]>;
type AlulaReceiversSuccessAction = DataSuccessAction<AlulaReceiver[]>;
type AlulaReceiversFailureAction = DataErrorAction<AlulaReceiver[]>;

export type AlulaReceiverGroupAction = DataAction<AlulaReceiverGroup>;
type AlulaReceiverGroupSuccessAction = DataSuccessAction<AlulaReceiverGroup>;
type AlulaReceiverGroupFailureAction = DataErrorAction<AlulaReceiverGroup>;

export type AlulaReceiverGroupsAction = DataAction<AlulaReceiverGroup[]>;
type AlulaReceiverGroupsSuccessAction = DataSuccessAction<AlulaReceiverGroup[]>;
type AlulaReceiverGroupsFailureAction = DataErrorAction<AlulaReceiverGroup[]>;

export type AlulaReceiverBindAction = DataAction<AlulaReceiverBind>;
type AlulaReceiverBindSuccessAction = DataSuccessAction<AlulaReceiverBind>;
type AlulaReceiverBindFailureAction = DataErrorAction<AlulaReceiverBind>;

export type AlulaReceiverBindsAction = DataAction<AlulaReceiverBind[]>;
type AlulaReceiverBindsSuccessAction = DataSuccessAction<AlulaReceiverBind[]>;
type AlulaReceiverBindsFailureAction = DataErrorAction<AlulaReceiverBind[]>;

export type AlulaEventSuccessAction = DataSuccessAction<AlulaEvent[]>;
type AlulaEventFailureAction = DataErrorAction<any>;

export class ClearDevicesByDealerId {
    readonly type = ActionTypes.ClearDevicesByDealerId;
    // constructor(public readonly payload: string) {}
}

export class ClearAlulaDevice {
    readonly type = ActionTypes.ClearAlulaDevice;
}

// device
export class CreateAlulaDevice implements AlulaDeviceAction {
    readonly type = ActionTypes.CreateAlulaDevice;
    constructor(public readonly payload: AlulaDevice) {}
}

export class CreateAlulaDeviceSuccess implements AlulaDeviceSuccessAction {
    readonly type = ActionTypes.CreateAlulaDeviceSuccess;
    constructor(public readonly result: AlulaDevice) {}
}

export class CreateAlulaDeviceFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.CreateAlulaDeviceFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

export class GetAlulaDevice implements Action {
    readonly type = ActionTypes.GetAlulaDevice;
    constructor(public readonly payload: { macAddress: string }) {}
}

export class GetAlulaDeviceSuccess implements AlulaDeviceSuccessAction {
    readonly type = ActionTypes.GetAlulaDeviceSuccess;
    constructor(public readonly result: AlulaDevice) {}
}

export class GetAlulaDeviceFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.GetAlulaDeviceFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

export class GetDevicesByReceiverGroupId implements Action {
    readonly type = ActionTypes.GetDevicesByReceiverGroupId;
    constructor(public readonly payload: { receiverGroupId: string }) {}
}

export class GetDevicesByReceiverGroupIdSuccess implements AlulaDevicesSuccessAction {
    readonly type = ActionTypes.GetDevicesByReceiverGroupIdSuccess;
    constructor(public readonly result: AlulaDevice[]) {}
}

export class GetDevicesByReceiverGroupIdFailure implements AlulaDevicesFailureAction {
    readonly type = ActionTypes.GetDevicesByReceiverGroupIdFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice[]>) {}
}

export class GetDevicesByDealerId implements Action {
    readonly type = ActionTypes.GetDevicesByDealerId;
    constructor(public readonly payload: { dealerId: string }) {}
}

export class GetDevicesByDealerIdSuccess implements AlulaDevicesSuccessAction {
    readonly type = ActionTypes.GetDevicesByDealerIdSuccess;
    constructor(public readonly result: AlulaDevice[]) {}
}

export class GetDevicesByDealerIdFailure implements AlulaDevicesFailureAction {
    readonly type = ActionTypes.GetDevicesByDealerIdFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice[]>) {}
}

export class GetAlulaDeviceEvents implements Action {
    readonly type = ActionTypes.GetAlulaDeviceEvents;
    constructor(public readonly payload: { deviceId: string; filters?: AlulaEventFilter }) {}
}

export class GetAlulaDeviceEventsSuccess implements AlulaEventSuccessAction {
    readonly type = ActionTypes.GetAlulaDeviceEventsSuccess;
    constructor(public readonly result: AlulaEvent[]) {}
}

export class GetAlulaDeviceEventsFailure implements AlulaEventFailureAction {
    readonly type = ActionTypes.GetAlulaDeviceEventsFailure;
    constructor(public readonly error: DataServiceError<any>) {}
}

export class UpdateAlulaDevice implements AlulaDeviceAction {
    readonly type = ActionTypes.UpdateAlulaDevice;
    constructor(public readonly payload: AlulaDevice) {}
}

export class UpdateAlulaDeviceSuccess implements AlulaDeviceSuccessAction {
    readonly type = ActionTypes.UpdateAlulaDeviceSuccess;
    constructor(public readonly result: AlulaDevice) {}
}

export class UpdateAlulaDeviceFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.UpdateAlulaDeviceFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

// user
export class CreateAlulaUser implements Action {
    readonly type = ActionTypes.CreateAlulaUser;
    constructor(public readonly payload: { user: AlulaUser; dealer?: AlulaDealer; device: AlulaDevice }) {}
}

export class CreateAlulaUserSuccess implements AlulaUserSuccessAction {
    readonly type = ActionTypes.CreateAlulaUserSuccess;
    constructor(public readonly result: AlulaUser) {}
}

export class CreateAlulaUserFailure implements AlulaUserFailureAction {
    readonly type = ActionTypes.CreateAlulaUserFailure;
    constructor(public readonly error: DataServiceError<AlulaUser>) {}
}

export class GetAlulaUser implements Action {
    readonly type = ActionTypes.GetAlulaUser;
    constructor(public readonly payload: { userType: number; email: string }) {}
}

export class GetAlulaUserByPartialUsername implements Action {
    readonly type = ActionTypes.GetAlulaUserByPartialUsername;
    constructor(public readonly payload: { partialUsername: string }) {}
}

export class GetAlulaUserSuccess implements AlulaUserSuccessAction {
    readonly type = ActionTypes.GetAlulaUserSuccess;
    constructor(public readonly result: AlulaUser) {}
}

export class GetAlulaUserFailure implements AlulaUserFailureAction {
    readonly type = ActionTypes.GetAlulaUserFailure;
    constructor(public readonly error: DataServiceError<AlulaUser>) {}
}

export class UpdateAlulaUser implements AlulaUserAction {
    readonly type = ActionTypes.UpdateAlulaUser;
    constructor(public readonly payload: AlulaUser) {}
}

export class UpdateAlulaUserSuccess implements AlulaUserSuccessAction {
    readonly type = ActionTypes.UpdateAlulaUserSuccess;
    constructor(public readonly result: AlulaUser) {}
}

export class UpdateAlulaUserFailure implements AlulaUserFailureAction {
    readonly type = ActionTypes.UpdateAlulaUserFailure;
    constructor(public readonly error: DataServiceError<AlulaUser>) {}
}

// enable security monitoring
export class EnableSecurityMonitoring implements Action {
    readonly type = ActionTypes.EnableSecurityMonitoring;

    constructor(
        public readonly payload: {
            device: AlulaDevice;
            dealerId: string;
            user: AlulaUser;
            project: Project;
            emitter?: EventEmitter<Action>;
            dataUpdate?: any;
            entityId: number;
            projectId?: number;
        }
    ) {}
}

export class EnableSecurityMonitoringSuccess implements Action {
    readonly type = ActionTypes.EnableSecurityMonitoringSuccess;

    constructor(
        public readonly result: {
            device: AlulaDevice;
            user: AlulaUser;
            project: Project;
        }
    ) {}
}

export class EnableSecurityMonitoringFailure implements DataErrorAction<any> {
    readonly type = ActionTypes.EnableSecurityMonitoringFailure;

    constructor(public readonly error: DataServiceError<any>) {}
}

// disable security monitoring
export class DisableSecurityMonitoring implements Action {
    readonly type = ActionTypes.DisableSecurityMonitoring;
    constructor(
        public readonly payload: {
            device: AlulaDevice;
            emitter?: EventEmitter<Action>;
            uuid?;
            csName?: string;
            projectId?: number;
            entityId: number;
        }
    ) {}
}

export class DisableSecurityMonitoringSuccess implements AlulaDeviceSuccessAction {
    readonly type = ActionTypes.DisableSecurityMonitoringSuccess;
    constructor(public readonly result: any) {}
}

export class DisableSecurityMonitoringFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.DisableSecurityMonitoringFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

export class DeactivateSecurityMonitoring implements Action {
    readonly type = ActionTypes.DeactivateSecurityMonitoring;
}

export class DeactivateSecurityMonitoringConfirmationDismiss implements Action {
    readonly type = ActionTypes.DeactivateSecurityMonitoringConfirmationDismiss;
}

// Assign Alula Device
export class AssignAlulaDevice implements Action {
    readonly type = ActionTypes.AssignAlulaDevice;

    constructor(public readonly payload: { customerId: string; deviceId: string }) {}
}

export class AssignAlulaDeviceSuccess implements Action {
    readonly type = ActionTypes.AssignAlulaDeviceSuccess;
    constructor(public readonly result: any) {}
}

export class AssignAlulaDeviceFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.AssignAlulaDeviceFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

// Unassign device
export class UnassignAlulaDevice implements AlulaDeviceAction {
    readonly type = ActionTypes.UnassignAlulaDevice;
    constructor(public readonly payload: AlulaDevice) {}
}

export class UnassignAlulaDeviceSuccess implements AlulaDeviceSuccessAction {
    readonly type = ActionTypes.UnassignAlulaDeviceSuccess;
    constructor(public readonly result: AlulaDevice) {}
}

export class UnassignAlulaDeviceFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.UnassignAlulaDeviceFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

// update device properties
export class UpdateAlulaDeviceReceiver implements AlulaDeviceAction {
    readonly type = ActionTypes.UpdateAlulaDeviceReceiver;
    constructor(public readonly payload: AlulaDevice, public callbackEmitter?: EventEmitter<Action>) {}
}

export class UpdateAlulaDeviceReceiverSuccess implements AlulaDeviceSuccessAction {
    readonly type = ActionTypes.UpdateAlulaDeviceReceiverSuccess;
    constructor(public readonly result: AlulaDevice) {}
}

export class UpdateAlulaDeviceReceiverFailure implements AlulaDeviceFailureAction {
    readonly type = ActionTypes.UpdateAlulaDeviceReceiverFailure;
    constructor(public readonly error: DataServiceError<AlulaDevice>) {}
}

export class ClearAlulaState implements Action {
    readonly type = ActionTypes.ClearAlulaState;
}

export class LoadAlulaStateItem implements Action {
    readonly type = ActionTypes.LoadAlulaStateItem;

    constructor(public readonly payload: string) {}
}

export class LoadedAlulaStateItem implements Action {
    readonly type = ActionTypes.LoadedAlulaStateItem;

    constructor(public readonly payload: string) {}
}

export type Actions =
    | ClearDevicesByDealerId
    | CreateAlulaUser
    | CreateAlulaUserSuccess
    | CreateAlulaUserFailure
    | GetAlulaUser
    | GetAlulaUserByPartialUsername
    | GetAlulaUserFailure
    | GetAlulaUserSuccess
    | UpdateAlulaUser
    | UpdateAlulaUserSuccess
    | UpdateAlulaUserFailure
    | CreateAlulaDevice
    | CreateAlulaDeviceSuccess
    | CreateAlulaDeviceFailure
    | GetAlulaDevice
    | GetAlulaDeviceSuccess
    | GetAlulaDeviceFailure
    | GetAlulaDeviceEvents
    | GetAlulaDeviceEventsSuccess
    | GetAlulaDeviceEventsFailure
    | UpdateAlulaDevice
    | UpdateAlulaDeviceSuccess
    | UpdateAlulaDeviceFailure
    | EnableSecurityMonitoring
    | EnableSecurityMonitoringSuccess
    | EnableSecurityMonitoringFailure
    | DisableSecurityMonitoring
    | DisableSecurityMonitoringSuccess
    | DisableSecurityMonitoringFailure
    | UpdateAlulaDeviceReceiver
    | UpdateAlulaDeviceReceiverSuccess
    | UpdateAlulaDeviceReceiverFailure
    | ClearAlulaState
    | LoadAlulaStateItem
    | LoadedAlulaStateItem
    | DeactivateSecurityMonitoring
    | DeactivateSecurityMonitoringConfirmationDismiss
    | ClearAlulaDevice;
